exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ForgottenPasswordComponent{width:70%}#ForgottenPasswordComponent h1{color:#0686d8}#ForgottenPasswordComponent .login{width:100%}@media screen and (min-width: 768px){#ForgottenPasswordComponent .login{width:50%}}#ForgottenPasswordComponent .white{color:#fff}#ForgottenPasswordComponent p{margin:.5rem 0;font-size:11px;font-style:italic;color:#0686d8}", ""]);

// exports
